class FunnelPromo extends HTMLElement {
  connectedCallback() {
    if (!this.querySelector('[data-clock]') || this.timer) return;
    this.updateClock();
    this.timer = setInterval(() => this.updateClock(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.timer);
    this.timer = null;
  }

  updateClock() {
    const now = new Date();
    const midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
    const remaining = Math.floor((midnight - now) / 1000);
    const values = {
      hours: Math.floor(remaining / 3600),
      minutes: Math.floor((remaining % 3600) / 60),
      seconds: remaining % 60,
    };
    for (const [part, value] of Object.entries(values)) {
      this.querySelector(`[data-clock="${part}"]`).textContent = String(value).padStart(2, '0');
    }
  }
}

if (!customElements.get('os-funnel-promo')) customElements.define('os-funnel-promo', FunnelPromo);
